import Heading from 'components/universal/heading';
import Paragraph from 'components/universal/paragraph';
import { RadioTwoBox } from 'components/universal/radio-two-box';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useNavigate } from 'react-router-dom';
import cls from './resetPage.module.scss';
import { Button } from 'components/universal/button';
import { PATHS } from 'constants/routes';

export const ResetPasswordPageView = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const firstLabel = 'first';
    const [selectedOption, setSelectedOption] = useState<string>(firstLabel);

    const onCancel = () => {
        navigate(PATHS.LOGIN);
    };
    
    return (
        <div className={cls.container}>
            <div className={cls.columnLeft}>
                <Heading
                    className={cls.heading}
                    headingLevel="h1"
                    headingStyle="h2"
                >
                    {t('resetPage.title')}
                </Heading>
                <Paragraph
                    className={cls.description}
                    >
                    {t('resetPage.description')}
                </Paragraph>
                <RadioTwoBox 
                    labelFirst={t('resetPage.radioFirstDescription')}
                    labelSecond={t('resetPage.radioSecondDescription')}
                    name="customRadio"
                    valueFirst="first"
                    valueSecond="second"
                    value={selectedOption}
                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setSelectedOption(e.target.value)}
                />
                <div
                    className={cls.buttonWrapper}
                    >
                    <Link to={PATHS.LOGIN}>
                        <Button 
                            className={`${cls.button} mx-auto mb-5`} 
                            styleType="border"
                        >
                            {t('resetPassword.goBackButton')}
                        </Button>
                    </Link>

                    <Link to={selectedOption === firstLabel ? PATHS.RESET_ACCESS : PATHS.RESET_PASSWORD}>
                        <Button 
                            className={`${cls.button} mx-auto mb-5`}
                        >
                            {t('resetPage.continue')}
                        </Button>
                    </Link>
                </div>
            </div>
        </div>
    );
};
